module.exports = __webpack_public_path__ + "img/normal-icon.05ff8d7c.svg";